export enum UserLoyaltyPopupTypeEnum {
  None = 0,
  VoucherWarning = 1,
  VoucherError = 2,
  CardWarning = 3,
  CardError = 4,
}
